import { render } from "./TheFooter.vue?vue&type=template&id=083ff363&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "../../assets/css/components/UI/TheFooter.css?vue&type=style&index=0&id=083ff363&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083ff363"]])

export default __exports__